import { resources } from "@constants/hardcoded-strings";
import { AxnAdminUserAccountStateTypes } from "@enums/axn-admin-user-account-state-types";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";
import { replaceOrganizationUser } from "@redux/actions/organization-users-actions";
import { restoreAxnAdminUserRequest } from "@requests/axnadmin-core/restore-axn-admin-user";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";

export const restoreOrganizationUserReduxRequest = (dispatch: Dispatch) => async (
    userId: string
): Promise<AxnAdminUser> => {
    const { data, error } = await restoreAxnAdminUserRequest(userId);
    if (data) {
        dispatch(replaceOrganizationUser(data.transferObject, AxnAdminUserAccountStateTypes.RESTORE));
            return data.transferObject;
        } else {
            if (error) {
                const errorResource = resources.requests.restoreOrganizationUser.error;
    
                logAndDisplayErrorModal(
                    dispatch,
                    error,
                    errorResource.title,
                    errorResource.message
                );
            }
        }

    return null;
};